export default {
  1: [
    {
      Id: "recllWKNCK2dtHuiL",
      Title: "10%",
      Quiz: 1,
      "Vrai/faux": "Vrai",
      Label: "C’est exact",
    },
    {
      Id: "recanwEZHhKf80Exi",
      Title: "25%",
      Quiz: 1,
      "Vrai/faux": "Faux",
      Label: "Pas exactement ",
    },
    {
      Id: "recml066F8kuRV66V",
      Title: "35%",
      Quiz: 1,
      "Vrai/faux": "Faux",
      Label: "Pas exactement ",
    },
  ],
  2: [
    {
      Id: "recr2ie5brhWlz6Od",
      Title: "Anglais et portugais",
      Quiz: 2,
      "Vrai/faux": "Vrai",
      Label: "Sim, that’s right !",
    },
    {
      Id: "recjbXtvaA2b8i4cH",
      Title: "Allemand et italien",
      Quiz: 2,
      "Vrai/faux": "Faux",
      Label: "Nein, non è giusto :-(",
    },
    {
      Id: "recdl95hmDCn2bRBv",
      Title: "Portugais et italien",
      Quiz: 2,
      "Vrai/faux": "Faux",
      Label: " No, està errado ",
    },
  ],
  3: [
    {
      Id: "recCETz2U9g9Gf5rt",
      Title: "Des services en ligne avec soutien dans leur utilisation",
      Quiz: 3,
      "Vrai/faux": "Vrai",
      Label: "En effet !",
    },
    {
      Id: "recmzkWUsb1Om6kpl",
      Title: "Des horaires d’ouverture des guichets au public élargis",
      Quiz: 3,
      "Vrai/faux": "Faux",
      Label: "Oui…mais pas seulement ! ",
    },
    {
      Id: "recUpa6SLk1pbHATL",
      Title: " Des personnes accompagnantes ",
      Quiz: 3,
      "Vrai/faux": "Faux",
      Label: "Oui…mais pas seulement ! ",
    },
  ],
  4: [
    {
      Id: "recdiVgNLRyagZvxw",
      Title:
        "Non, le permis F ne s’accompagne pas d’un droit de travailler en Suisse",
      Quiz: 4,
      "Vrai/faux": "Faux",
      Label: " Non. Un autre essai ?",
    },
    {
      Id: "recO2m3MYeHANqKAc",
      Title:
        "Oui, sous condition et moyennant de lourdes démarches administratives",
      Quiz: 4,
      "Vrai/faux": "Faux",
      Label: " Non. Un autre essai ?",
    },
    {
      Id: "recbaV1Y1ljxPPezT",
      Title: "Oui… et c’est moins compliqué qu’on ne l’imagine !",
      Quiz: 4,
      "Vrai/faux": "Vrai",
      Label: "Oui, en effet, c’est possible !",
    },
  ],
  5: [
    {
      Id: "recgo2a0sDMUVIOmV",
      Title: "Lui proposer de revenir avec un·e proche capable de traduire",
      Quiz: 5,
      "Vrai/faux": "Faux",
      Label: "Nous déconseillons cette solution. ",
    },
    {
      Id: "recUaTD3r6tZ2H0yL",
      Title: "Faire appel à un·e interprète communautaire ",
      Quiz: 5,
      "Vrai/faux": "Vrai",
      Label: "Bingo",
    },
    {
      Id: "recHrkkheLMIfprIz",
      Title: "Faire appel à un service de traduction",
      Quiz: 5,
      "Vrai/faux": "Faux",
      Label: "Nous déconseillons cette solution. ",
    },
  ],
  6: [
    {
      Id: "recQ23vc0otsRMqPF",
      Title: "Surestimer leurs compétences langagières",
      Quiz: 6,
      "Vrai/faux": "Vrai",
      Label: "Effectivement ",
    },
    {
      Id: "rec0Cr8DQnwvm6TM4",
      Title: "Sous-estimer leurs compétences langagières",
      Quiz: 6,
      "Vrai/faux": "Faux",
      Label: "Pardon, je n'ai pas bien compris, vous pouvez répéter? ",
    },
  ],
  7: [
    {
      Id: "recai6v9wpR2U0GqN",
      Title: "Bouche bée, je n’ai rien pu répondre",
      Quiz: 7,
      "Vrai/faux": "Vrai",
      Label: "Restons vigilant·e·s",
    },
    {
      Id: "recQibAkKEEB34dRh",
      Title: "J’ai manifesté mon désaccord à l’auteur·e de ces propos",
      Quiz: 7,
      "Vrai/faux": "Vrai",
      Label: "Restons vigilant·e·s",
    },
    {
      Id: "recTAzLI6cIcNqb6S",
      Title: "J’en ai parlé à ma hiérarchie ou à une permanence spécialisée",
      Quiz: 7,
      "Vrai/faux": "Vrai",
      Label: "Restons vigilant·e·s",
    },
    {
      Id: "rec90K7t2vM8uCRmg",
      Title: "Ce type de situation ne m’est jamais arrivé ",
      Quiz: 7,
      "Vrai/faux": "Vrai",
      Label: "Restons vigilant·e·s",
    },
  ],
  8: [
    {
      Id: "reczdyaXnl4oKyuCj",
      Title: "Rien, elle ne m’a rien affirmé de clair",
      Quiz: 8,
      "Vrai/faux": "Faux",
      Label:
        "Si la situation éveille une inquiétude, il vaudrait mieux ne pas la laisser sans suite. ",
    },
    {
      Id: "recikUvjd9DvNvYMk",
      Title: "Je rapporte mon inquiétude à ma hiérarchie et/ou au BCI",
      Quiz: 8,
      "Vrai/faux": "Vrai",
      Label: "Bon réflexe !",
    },
    {
      Id: "recT96L3hFIhVxuNs",
      Title:
        "Je signale la situation à la police et/ou contacte les numéros d’urgence ",
      Quiz: 8,
      "Vrai/faux": "Faux",
      Label:
        "Si vous ne craignez pas pour la sécurité immédiate de la personne, cette réaction ne semble pas idéale. ",
    },
  ],
  9: [
    {
      Id: "recfWSEJHNHRo9M9u",
      Title: "La famille a trouvé la procédure trop longue ",
      Quiz: 9,
      "Vrai/faux": "Faux",
      Label: "Ce n’est pas ça, réessayez !",
    },
    {
      Id: "recJBlyAwpGOQOegt",
      Title:
        "La famille ne comprend pas pourquoi il faudra recommencer à zéro ",
      Quiz: 9,
      "Vrai/faux": "Faux",
      Label: "Ce n’est pas ça, réessayez !",
    },
    {
      Id: "recqfiitkqiHsfqQa",
      Title:
        "Le signe « parfait » représente une insulte dans la culture de la famille en question",
      Quiz: 9,
      "Vrai/faux": "Vrai",
      Label: "Correct !",
    },
  ],
  10: [
    { Id: "recJaRDP9HYlnahL8", Quiz: 10 },
    { Id: "recFoiLHazCmhZWJ6", Quiz: 10 },
    { Id: "rec7vxLllZVH5eVKq", Quiz: 10 },
  ],
};
